import { Component, Inject } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
    selector: 'bp2s-notify',
    templateUrl: './notify.component.html',
    styleUrls: ['./notify.component.scss'],
    standalone: false
})
export class NotifyComponent {

  constructor(public snackBarRef: MatSnackBarRef<NotifyComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: {
      message: string,
      panelClass: string,
      duration: number,
      type: string
    }) { }

}
